import { Component, OnInit } from '@angular/core';
import { Remittanceinfo } from '../../../classes/remittanceinfo';
import { NgForm } from '@angular/forms';
import { RemittanceInfoService } from '../../../services/remittance-info.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../../../shared/services/user.service';
import { CompanyService } from '../../../services/company.service';

@Component({
  selector: 'app-remittance-info-page',
  templateUrl: './remittance-info-page.component.html',
  styleUrls: ['./remittance-info-page.component.scss']
})
export class RemittanceInfoPageComponent implements OnInit {
  remittanceInfo: Remittanceinfo = <Remittanceinfo>{};
  remittanceInfos: Remittanceinfo[] = [];
  edit: boolean[] = [];
  editing: boolean[] = [];
  sub: any;
  orgId: number;
  adding: boolean;
  isAdmin: boolean;
  error: string = '';
  company: any;
  steps: any;
  incomplete: boolean;
  state: any;
  focus: any[] = [];
  rpFocus: boolean = false;
  eiFocus: boolean = false;
  freqFocus: boolean = false;
  openRp: boolean = false;
  openEi: boolean = false;
  openFreq: boolean = false;
  openRps: boolean[] = [];
  openEis: boolean[] = [];
  openFreqs: boolean[] = [];

  constructor(
    private RemittanceInfoService: RemittanceInfoService,
    private route: ActivatedRoute,
    private titleService: Title,
    private UserService: UserService,
    private CompanyService: CompanyService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getRemittanceInfos();
    this.titleService.setTitle('Remittance Info');
  }

  getRemittanceInfos() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.RemittanceInfoService.getRemittanceInfo(this.orgId)
        .subscribe(rp => {
          this.remittanceInfos = JSON.parse(rp.rp_accounts || '[]');
          this.edit = this.remittanceInfos.map(rp => {
            return false;
          })
          this.editing = JSON.parse(JSON.stringify(this.edit));
          this.openRps = JSON.parse(JSON.stringify(this.edit));
          this.openEis = JSON.parse(JSON.stringify(this.edit));
          this.openFreqs = JSON.parse(JSON.stringify(this.edit));
          this.focus = this.remittanceInfos.map(rp => {
            return {
              rpFocus: false,
              eiFocus: false,
              freqFocus: false
            };
          })
          this.getComplete();
        }, err => {
          console.log(err)
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
        })

    });
    this.UserService.getUserInfo()
      .subscribe(user => {
        console.log(user)
        let u: any = JSON.parse(user.user);
        this.isAdmin = u.admin;
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  getComplete() {
    this.CompanyService.getCompany(this.orgId)
      .subscribe(company => {
        this.company = JSON.parse(company.organization);
        this.steps = JSON.parse(company.steps);
        this.incomplete = this.steps.slice(0, 3).some(s => {
          console.log(s)
          return !s[2];
        })
        this.state = JSON.parse(company.state);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }


  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  add(remittanceForm: NgForm) {
    this.adding = true;
    if (remittanceForm.invalid) {
      return;
    }
    if (+this.remittanceInfo.employer_ei_rate > 100) {
      this.remittanceInfo.employer_ei_rate = '100';
    }
    this.RemittanceInfoService.addRemittanceInfo(this.orgId, this.remittanceInfo)
      .subscribe(rp => {
        this.adding = false;
        remittanceForm.reset();
        this.remittanceInfo = <Remittanceinfo>{};
        this.getRemittanceInfos();
        if(!this.isAdmin) window.analytics.track("Self-Signup Remittance Info Added", {OrgId: this.orgId});
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
        if(!this.isAdmin) window.analytics.track("Self-Signup Remittance Info Addition Failed", {OrgId: this.orgId, reason: err._body});
      })
  }

  remove(id: number) {
    this.RemittanceInfoService.deleteRemittanceInfo(this.orgId, id)
      .subscribe(rp => {
        this.getRemittanceInfos();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  editInfo(index: number) {
    this.edit[index] = true;
  }

  complete(id: number, remittanceForm: NgForm, remittanceInfo: Remittanceinfo, index: number) {
    this.editing[index] = true;
    if (remittanceForm.invalid) {
      return;
    }
    if (+this.remittanceInfo.employer_ei_rate > 100) {
      this.remittanceInfo.employer_ei_rate = '100';
    }
    this.RemittanceInfoService.editRemittanceInfo(this.orgId, id, remittanceInfo)
      .subscribe(rp => {
        this.editing[index] = false;
        this.getRemittanceInfos();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  showError(ev: string) {
    this.error = ev;
  }

  onClickedOutside(e: any) {
    console.log('Clicked outside:', e);
    if (e.target.className != 'fa fa-question-circle-o') {
      this.openRp = false;
      this.openEi = false;
      this.openFreq = false;
      this.openRps = this.openRps.map(r => { return false });
      this.openEis = this.openEis.map(r => { return false });
      this.openFreqs = this.openFreqs.map(r => { return false });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/company-setup/remittance-info-page/remittance-info-page.component.ts